
import Vue, { PropType } from 'vue'

// import JImageGallery from '@/ui/controls/JImageGallery.vue'
import Plant from '@/models/Plant'

import { sortItemsByTimestampsDesc } from '@/helpers/sorters'
import Image from '@/models/Image'

export default Vue.extend({
  components: {
    // JImageGallery,
  },
  props: {
    plant: Object as PropType<Plant>,
  },
  data: () => ({
    //
  }),
  computed: {
    sortedImages(): Image[] {
      return this.plant.allImages.slice().sort(sortItemsByTimestampsDesc)
    },
  },
  methods: {
    //
  },
})
